import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideAppInitializer, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor, AuthService } from '@olonera/auth';
import { API_CONFIG, PractitionerOptionsStore } from '@olonera/shared';
import { environment } from '../environments/environment';
import { firstValueFrom } from 'rxjs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: API_CONFIG, useValue: environment },
    provideAppInitializer(() => {
      return inject(PractitionerOptionsStore).load();
    }),
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      // Only sync if the user is already logged in (has a token in localStorage).
      // This refreshes stale localStorage data (e.g. BAA grace period status)
      // without requiring the practitioner to re-login.
      if (localStorage.getItem('token') && localStorage.getItem('user')) {
        return firstValueFrom(authService.syncCurrentUser());
      }
      return Promise.resolve();
    }),
  ],
};

